<template>
  <div 
    class="loader" 
    :class="$attrs.class"
    v-show="show"
  />
  <div 
    class="loader-overlay" 
    :class="$attrs.class"
    v-show="show"
  />
  <slot></slot>
</template>

<script>
import NetteAjax from '../nette/NetteAjax'

export default {
  props: [
    'name'
  ],
  data () {
    return {
    }
  },
  created () {
    if (!(this.name in NetteAjax.ext('spinner').spinners)) {
      NetteAjax.ext('spinner').spinners[this.name] = false
    }
  },
  computed: {
    show () {
      return NetteAjax.ext('spinner').spinners[this.name]
    }
  },
  methods: {
  }
}
</script>
